var map = {
	"./": 324,
	"./Results.dictionaty": 349,
	"./Results.dictionaty.json": 349,
	"./Results.explanation": 1165,
	"./Results.explanation.ts": 1165,
	"./Results.module.scss": 1166,
	"./ResultsPage": 1167,
	"./ResultsPage.tsx": 1167,
	"./ResultsPageDeferred": 382,
	"./ResultsPageDeferred.tsx": 382,
	"./actions": 336,
	"./actions.ts": 336,
	"./components/Filters": 1025,
	"./components/Filters/": 1025,
	"./components/Filters/ButtonBar": 948,
	"./components/Filters/ButtonBar/": 948,
	"./components/Filters/ButtonBar/ButtonBar.module.scss": 1064,
	"./components/Filters/ButtonBar/index": 948,
	"./components/Filters/ButtonBar/index.tsx": 948,
	"./components/Filters/DatePick": 1002,
	"./components/Filters/DatePick/": 1002,
	"./components/Filters/DatePick/DatePick.module.scss": 1088,
	"./components/Filters/DatePick/index": 1002,
	"./components/Filters/DatePick/index.tsx": 1002,
	"./components/Filters/DatePick/types": 1169,
	"./components/Filters/DatePick/types.ts": 1169,
	"./components/Filters/Filter.module.scss": 1168,
	"./components/Filters/Filters.dictionary": 1092,
	"./components/Filters/Filters.dictionary.json": 1092,
	"./components/Filters/Search": 1003,
	"./components/Filters/Search/": 1003,
	"./components/Filters/Search/Search.dictionary": 1061,
	"./components/Filters/Search/Search.dictionary.json": 1061,
	"./components/Filters/Search/Search.module.scss": 1089,
	"./components/Filters/Search/index": 1003,
	"./components/Filters/Search/index.tsx": 1003,
	"./components/Filters/Sorts": 1004,
	"./components/Filters/Sorts/": 1004,
	"./components/Filters/Sorts/Sorts.dictionary": 1062,
	"./components/Filters/Sorts/Sorts.dictionary.json": 1062,
	"./components/Filters/Sorts/Sorts.module.scss": 1090,
	"./components/Filters/Sorts/index": 1004,
	"./components/Filters/Sorts/index.tsx": 1004,
	"./components/Filters/SportsList": 1005,
	"./components/Filters/SportsList/": 1005,
	"./components/Filters/SportsList/SportsList.module.scss": 1091,
	"./components/Filters/SportsList/index": 1005,
	"./components/Filters/SportsList/index.tsx": 1005,
	"./components/Filters/index": 1025,
	"./components/Filters/index.tsx": 1025,
	"./components/Tables": 1007,
	"./components/Tables/": 1007,
	"./components/Tables/Table": 949,
	"./components/Tables/Table/": 949,
	"./components/Tables/Table/Header": 912,
	"./components/Tables/Table/Header/": 912,
	"./components/Tables/Table/Header/Header.dictionary": 950,
	"./components/Tables/Table/Header/Header.dictionary.json": 950,
	"./components/Tables/Table/Header/Header.module.scss": 1008,
	"./components/Tables/Table/Header/index": 912,
	"./components/Tables/Table/Header/index.tsx": 912,
	"./components/Tables/Table/Match": 913,
	"./components/Tables/Table/Match/": 913,
	"./components/Tables/Table/Match/Match.module.scss": 1009,
	"./components/Tables/Table/Match/index": 913,
	"./components/Tables/Table/Match/index.tsx": 913,
	"./components/Tables/Table/Table.dictionary": 1010,
	"./components/Tables/Table/Table.dictionary.json": 1010,
	"./components/Tables/Table/Table.module.scss": 1065,
	"./components/Tables/Table/index": 949,
	"./components/Tables/Table/index.tsx": 949,
	"./components/Tables/Tables.dictionary": 1066,
	"./components/Tables/Tables.dictionary.json": 1066,
	"./components/Tables/Tables.module.scss": 1093,
	"./components/Tables/index": 1007,
	"./components/Tables/index.tsx": 1007,
	"./constants": 831,
	"./constants.ts": 831,
	"./index": 324,
	"./index.tsx": 324,
	"./reducer": 358,
	"./reducer.ts": 358,
	"./types": 1115,
	"./types.ts": 1115,
	"./utils/getScores": 951,
	"./utils/getScores.ts": 951,
	"./utils/sort": 1006,
	"./utils/sort.ts": 1006,
	"./utils/sportsList": 1063,
	"./utils/sportsList.ts": 1063
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1287;
module.exports = webpackContext;